import { all, put, retry, select, takeEvery } from 'redux-saga/effects';
import ActionTypes from '../../../../Data/ActionTypes';
import { ComponentTypes } from '../../../../Data/Components';
import getBrandsQuery from './getBrandsQuery';
import { preloadImage } from '../../../../Utils/utils';
import logToConsole from '../../../../Utils/logToConsole';

/**
 * Todo: Add description
 */
export function* getSupplierCardLogosWorker() {
  const maxTries = 3;
  const delayLength = 3000;

  const { components } = yield select();

  const supplierCardComponents = Object.values(components).filter(
    (component) => component.component.type === ComponentTypes.SUPPLIER_CARD
  );

  const selectAndConnectComponents = Object.values(components).filter(
    (component) =>
      component.component.type === ComponentTypes.SELECT_AND_CONNECT
  );

  if (
    supplierCardComponents.length === 0 &&
    selectAndConnectComponents.length === 0
  ) {
    return;
  }

  try {
    const supplierIds = [
      ...supplierCardComponents.map(
        (component) => component.component.additionalSettings.supplier_id
      ),
      ...selectAndConnectComponents.flatMap((component) =>
        component.component.additionalSettings.suppliers.map(
          (supplier) => supplier.supplier_id
        )
      ),
    ].filter(Boolean);

    if (supplierIds.length === 0) {
      return;
    }

    const args = {
      variables: {
        supplierIds: [...new Set(supplierIds)],
      },
    };
    const brands = yield retry(maxTries, delayLength, getBrandsQuery, args);

    const supplierCardBrands = supplierCardComponents.map((component) => ({
      componentId: component.component.id,
      brand: brands.find(
        (brand) =>
          brand.supplierId ===
          component.component.additionalSettings.supplier_id
      ),
    }));

    // Preload each brand's logo URL
    supplierCardBrands.forEach((supplierCardBrand) => {
      if (supplierCardBrand.brand && supplierCardBrand.brand.brandLogoUrl) {
        preloadImage(supplierCardBrand.brand.brandLogoUrl);
      }
    });

    if (supplierCardBrands.length > 0) {
      yield all(
        supplierCardBrands.map((supplierCardBrand) =>
          put({
            type: 'COMPONENTS/setSupplierCardBrandLogoUrl',
            payload: {
              componentId: supplierCardBrand.componentId,
              brandLogoUrl: supplierCardBrand.brand.brandLogoUrl,
            },
          })
        )
      );
    }

    const selectAndConnectBrands = selectAndConnectComponents.map(
      (component) => ({
        componentId: component.component.id,
        brands: component.component.additionalSettings.suppliers.map(
          (supplier) => ({
            supplierId: supplier.supplier_id,
            brand: brands.find(
              (brand) => brand.supplierId === supplier.supplier_id
            ),
          })
        ),
      })
    );

    selectAndConnectBrands.forEach((selectAndConnectBrand) => {
      selectAndConnectBrand.brands.forEach((brand) => {
        if (brand.brand && brand.brand.brandLogoUrl) {
          preloadImage(brand.brand.brandLogoUrl);
        }
      });
    });

    if (selectAndConnectBrands.length > 0) {
      yield all(
        selectAndConnectBrands.flatMap((selectAndConnectBrand) =>
          selectAndConnectBrand.brands.map((brand, index) =>
            put({
              type: 'COMPONENTS/setSelectAndConnectCardBrandLogoUrl',
              payload: {
                componentId: selectAndConnectBrand.componentId,
                index,
                brandLogoUrl: brand.brand.brandLogoUrl,
                brandName: brand.brand.brandName,
                brandId: brand.brand.brandId,
                brandRevisionId: brand.brand.brandRevisionId,
              },
            })
          )
        )
      );
    }
  } catch (error) {
    // TODO maybe we want to add some logging here or remove this?
    logToConsole.error(error);
  }
}

export default function* getSupplierCardLogosWatcher() {
  yield takeEvery(
    ActionTypes.GET_SUPPLIER_CARD_LOGOS,
    getSupplierCardLogosWorker
  );
}
